import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {},
	hydratable: true
});

export default app;